module.exports = __webpack_public_path__ + "img/banner-checktalkie.bac0a4c5.png";